import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { Row, Button } from 'react-bootstrap';
import UserService from '../../../../services/users-auth';
import Fiscal from './fiscal';


const ListarFiscais = () => {

    const [fiscais, setFiscais] = useState([]);
    const [editar, setEditar] = useState("");
    const [senha, setSenha] = useState("");
    const [fiscal, setFiscal] = useState("");



    async function fetchFiscais() {
        const response = await UserService.listar();
        if (response.data.length >= 1) {
            setFiscais(response.data)
        } else {
            setFiscais([])
        }
    }

    const handleEditar = (id) => {
        setFiscal(id);
        setEditar(true)
    }

    const handleSenha = (id) => {
        setFiscal(id);
        setSenha(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o fiscal?')) {
            await UserService.deletar(id)
            alert("Fiscal deletado com sucesso!")
            fetchFiscais();
        }
    }

    useEffect(() => {
        fetchFiscais();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/usuarios/editar/${fiscal}`} />
        )
    } else if (senha) {
        return (
            <Navigate to={`/restrito/usuarios/senha/${fiscal}`} />
        )
    } else {
        return (
            <Fragment>
                <Row xs={1} lg={3}>
                    {fiscais.map((fiscal, index) =>
                        <Fiscal
                            fetchFiscais={fetchFiscais}
                            fiscal={fiscal}
                            key={index}
                            editar={handleEditar}
                            deletar={deletar}
                            senha={handleSenha}
                        />
                    )}
                </Row>
                <br />
                <Link to="/restrito/usuarios">
                    <Button variant='danger'>Voltar</Button>
                </Link>
            </Fragment>

        )
    }
}

export default ListarFiscais;